<template lang="pug">
  .Map.AnalyticsMap
    .mapid(ref='mapRef')
    .LegendWrapper
      div(ref='legend')
        .Map-legend.Legend Legend will be here

</template>

<script>
  import { svgLeafletIcon, random_rgb, styleLeafletZoomControls, stylePrintControl, styleLayerControl } from "@/helpers/utils"
  import * as L from "leaflet"
  import "leaflet.markercluster"
  import '@/helpers/leaflet-patch-browser-print'
  import "@/helpers/leaflet-ruler"
  import "@/helpers/leaflet-legend"
  import "@/helpers/leaflet-group"
  import "@/helpers/leaflet-image"


  export default {
    name: "analytics-map",
    data() {
      return {
        mymap: null,
        layers: {},
      }
    },
    computed: {
      workspace() {
        return this.$store.getters.workspace
      },
      bounds() {
        return this.mymap.getBounds()
      },
      analyticsTerritoryType() {
        return this.$store.getters.analyticsTerritoryType
      },
      separatedTerritories() {
        return this.$store.getters.separatedTerritories || []
      },
      admTerritories() {
        return this.$store.getters.admTerritories
      },
      zoneGroups() {
        return this.$store.getters.zoneGroups
      },
      currentTerritoriesList() {
        return this.$store.getters.analyticsTerritoriesList
      },
    },
    props: {
      resize: {
        type: Object | null
      }
    },
    watch: {
      resize() {
        this.mymap.invalidateSize()
      },
      currentTerritoriesList() {
        this.drawTerritories()
      }
    },
    created: function() {
      delete L.Icon.Default.prototype._getIconUrl

      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png")
      })
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.mymap = L.map(this.$refs['mapRef']).setView(
          [55.603246, 37.0915562],
          8
        )
        let osm = L.tileLayer("https://api.mapbox.com/styles/v1/anjelikaptrv/ck4cuz8z903v41dmwc1nfcz37/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYW5qZWxpa2FwdHJ2IiwiYSI6ImNrNGN1eWk4ajByYTczcnA4eG0xMWVjaW0ifQ.JjJlYg3uS4ifA6B0h1lsaA", {
          // maxZoom: 8,
        })

        /* let osm = L.tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          // maxZoom: 8,
        })*/
        osm.addTo(this.mymap)

        let cadastermap = L.tileLayer.wms(
          "http://pkk5.rosreestr.ru/arcgis/services/Cadastre/CadastreWMS/MapServer/WMSServer",
          {
            layers:
              "0,1,2,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,23,24,25,26,27,28,29,30,31",
            format: "image/png",
            transparent: true,
            zIndex: 20
          }
        )

        /*L.control.legend({
          position: 'bottomright',
        }).addTo(this.mymap)
        document.getElementsByClassName("legend-container")[0].appendChild( this.$refs.legend )*/
        L.control.ruler({
          position: 'bottomright'
        }).addTo(this.mymap)


        L.control.browserPrint({
          position: 'bottomright'
        }).addTo(this.mymap)
        stylePrintControl()

        L.easyPrint({
          title: 'Сохранить как .PNG',
          position: 'bottomright',
          exportOnly: true,
        }).addTo(this.mymap)

        L.control.group({
          position: 'bottomright',
          collapsed: true,
          //controlClassesToToggle: ['leaflet-ruler', 'leaflet-control-browser-print', 'leaflet-control-legend', 'leaflet-control-image']
          controlClassesToToggle: ['leaflet-ruler', 'leaflet-control-browser-print', 'leaflet-control-image']
        }).addTo(this.mymap)

        L.control
          .layers({ osm: osm }, { "кадастровая карта": cadastermap }, {position: 'bottomright'})
          .addTo(this.mymap)
        styleLeafletZoomControls(this.mymap)
        styleLayerControl()

        this.drawTerritories()
      },
      drawTerritories() {
        this.removeAllTerritories()
        this.currentTerritoriesList.forEach(territory => {
          let layer = null

          layer = L.geoJSON(territory.boundary)
          this.layers[territory.id] = layer
          layer.setStyle((feature) => {
            return {
              color: '#FDFEFD',
              weight: 1,
              fillColor: territory.color || 'grey',
              fillOpacity: 0.3
            }
          })
          this.addTerritory(layer)
        })
      },
      addTerritory(layer) {
        this.mymap.addLayer(layer)
      },
      removeTerritory(layer) {
        this.mymap.removeLayer(layer)
      },
      removeAllTerritories() {
        for(let key in this.layers) {
          this.removeTerritory(this.layers[key])
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .LegendWrapper {display: none;}
</style>

<style lang="scss">
  @import "../../../node_modules/leaflet/dist/leaflet.css";
  @import "../../../node_modules/leaflet.markercluster/dist/MarkerCluster.css";
  @import "../../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css";
  @import '~base';
  .mapid {
    width: 100%;
    height: 100%;
  }

  .AnalyticsMap {
    width: 100%;
    height: 100%;

    .leaflet-tile-container {
      opacity: 0.5;
    }

    .leaflet-container{
      background: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/analytics/Map.vue